import { Loader2, PenTool } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { getPublicQuoteStrings, type PublicQuoteLocale } from '@/lib/publicQuoteLocale';

interface BoxSignDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  embedUrl: string | null;
  locale: PublicQuoteLocale;
}

export default function BoxSignDialog({ open, onOpenChange, embedUrl, locale }: BoxSignDialogProps) {
  const t = getPublicQuoteStrings(locale).boxSign;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[95vw] w-[95vw] h-[90vh] p-0 gap-0">
        <DialogHeader className="px-6 py-4 border-b shrink-0">
          <DialogTitle className="flex items-center gap-2">
            <PenTool className="h-5 w-5" />
            {t.title}
          </DialogTitle>
        </DialogHeader>
        <div className="flex-1 min-h-0">
          {embedUrl ? (
            <iframe
              src={embedUrl}
              className="w-full h-full border-0"
              allow="camera; microphone"
              title={t.iframeTitle}
            />
          ) : (
            <div className="flex items-center justify-center h-full">
              <div className="text-center">
                <Loader2 className="h-8 w-8 animate-spin mx-auto mb-2 text-muted-foreground" />
                <p className="text-muted-foreground">{t.loading}</p>
              </div>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
